import { render, staticRenderFns } from "./NovoAtendimentoLauncher.vue?vue&type=template&id=518fa624&scoped=true"
import script from "./NovoAtendimentoLauncher.vue?vue&type=script&lang=js"
export * from "./NovoAtendimentoLauncher.vue?vue&type=script&lang=js"
import style0 from "./NovoAtendimentoLauncher.vue?vue&type=style&index=0&id=518fa624&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "518fa624",
  null
  
)

export default component.exports